import type {GraphQlDocument} from '@sail/data';

export function getOperationName<TData, TVariables, TPermissions>(
  query: GraphQlDocument<TData, TVariables, TPermissions>,
): string {
  const operationDefinition = query.definitions.find(
    (definition) => definition.kind === 'OperationDefinition',
  );

  return operationDefinition?.name?.value ?? 'unknown';
}

export function isEmptyObjectToken(token: unknown): boolean {
  return (
    typeof token === 'object' &&
    token !== null &&
    !Array.isArray(token) &&
    Reflect.ownKeys(token).length === 0
  );
}
